'use client';

import { useState, useEffect } from 'react';

const taglines = [
  "Rediscover Community",
  "The Digital Sidewalk",
  "Local Life, in the Palm of Your Hand"
];

export function HeroSection() {
  const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTaglineIndex((prevIndex) => 
        (prevIndex + 1) % taglines.length
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="min-h-screen bg-transparent flex items-center justify-center px-6 py-20">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-8">
          <h1 className="font-poppins text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
            Locale reconnects people to{' '}
            <span className="text-locale-primary">real-life experiences</span>{' '}
            by breaking digital isolation, empowering{' '}
            <span className="text-locale-secondary">local businesses</span>, and bringing{' '}
            <span className="text-locale-accent">community</span> to the palm of your hand.
          </h1>
        </div>
        
        <div className="h-16 flex items-center justify-center">
          <p className="font-poppins text-xl md:text-2xl text-gray-600 transition-all duration-500 ease-in-out">
            {taglines[currentTaglineIndex]}
          </p>
        </div>
      </div>
    </section>
  );
}